import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_ZONES_BY_SITE,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/getZonesBySite.js